import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {Button, Card} from "antd";
import {getRegulatoryBody} from "../actions";
import {getRegulatoryBodyReportingCategories} from "./actions";
import ResponsiveTable from "../../common/ResponsiveTable";
import {decodeParams} from "../../utils/params";

class ReportingCategoriesPage extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    /* state */
    loading: PropTypes.bool.isRequired,
    reportingCategories: PropTypes.array.isRequired,
    regulatoryBody: PropTypes.object.isRequired,
    /* actions */
    getReportingCategories: PropTypes.func.isRequired,
    getRegulatoryBody: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.regulatoryBodyId !== prevProps.match.params.regulatoryBodyId) this.load();
  }

  load = () => {
    const {regulatoryBodyId} = decodeParams(this.props.match.params);
    this.props.getRegulatoryBody({regulatoryBodyId});
    this.props.getReportingCategories({regulatoryBodyId});
  };

  addCategory() {
    const bodyId = decodeParams(this.props.match.params).regulatoryBodyId;
    this.props.history.push(`/regulatory-reporting/body/add-category/${bodyId}`);
  }

  render() {
    const {
      history, reportingCategories, regulatoryBody, loading,
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Unit',
        dataIndex: 'reportingUnit',
        key: 'reportingUnit',
      },
      // {
      //   fixed: 'right',
      //   width: 80,
      //   title: 'Action',
      //   key: 'action',
      //   render: (_, {reportingCategoryId}) => <Link key="packs" to={`/bulk-consignment/${reportingCategoryId}`}>Packs</Link>
      // }
    ];
    const bodyName = regulatoryBody ? regulatoryBody.name : '?';
    const title = `${bodyName} Reporting Categories`;
    return (<React.Fragment>
      <Card bordered={false} title={[
        <Button key="back-button" icon="arrow-left" onClick={() => history.push('/regulatory-reporting/list-bodies')}/>,
        ' ',
        title,
      ]} extra={<Button type="primary" icon="plus" onClick={this.addCategory.bind(this)}>Add</Button>}>
        <ResponsiveTable
          loading={loading}
          columns={columns}
          dataSource={reportingCategories}
          rowKey="name"
        />
      </Card>
    </React.Fragment>);
  }
}

const mapStateToProps = state => ({
  loading: state.regulatoryBodyReportingCategory.regulatoryBodyReportingCategoriesLoading ||
    state.regulatoryBody.regulatoryBodyLoading,
  reportingCategories: state.regulatoryBodyReportingCategory.regulatoryBodyReportingCategories,
  regulatoryBody: state.regulatoryBody.regulatoryBody || {},
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  getRegulatoryBody,
  getReportingCategories: getRegulatoryBodyReportingCategories,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(ReportingCategoriesPage);



// WEBPACK FOOTER //
// ./src/RegulatoryBody/ReportingCategory/ReportingCategoriesPage.js